import { Component, OnInit } from '@angular/core';
import { PreferenceService, PreferenceType } from 'src/app/core/services/preference.service';


@Component({
  selector: 'app-horizontal',
  templateUrl: './horizontal.component.html',
  styleUrls: ['./horizontal.component.scss']
})

/**
 * Horizontal Component
 */
export class HorizontalComponent implements OnInit {

  constructor(private userPreferenceService: PreferenceService) { }


  ngOnInit(): void {
    document.documentElement.setAttribute('data-layout', 'horizontal');   
    document.documentElement.setAttribute('data-preloader', 'disable');

    this.userPreferenceService.currentPreference
      .subscribe((data: PreferenceType) => {
        if (data) {
          let theme = data.theme;
          document.documentElement.setAttribute('data-topbar', theme.topbar);
          document.documentElement.setAttribute('data-sidebar', theme.sidebar);
          document.documentElement.setAttribute('data-sidebar-size', theme.size);
          document.documentElement.setAttribute('data-layout-style', theme.sidebarView);
          document.documentElement.setAttribute('data-layout-mode', theme.mode);
          document.documentElement.setAttribute('data-layout-width', theme.width);
          document.documentElement.setAttribute('data-layout-position', theme.position);
          //document.documentElement.setAttribute('data-preloader', theme.preLoader);
        }
    });

  }

  /**
   * on settings button clicked from topbar
   */
   onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    const rightBar = document.getElementById('theme-settings-offcanvas');
    if(rightBar != null){
      rightBar.classList.toggle('show');
      rightBar.setAttribute('style',"visibility: visible;");
    }
  }
}
